import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useWebSocketStore } from '@/stores/websocket'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/repositories',
      name: 'repositories',
      component: () => import('@/views/RepositoriesView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: () => import('@/views/AlertsView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/alerts/templates',
      name: 'alert-templates',
      component: () => import('@/views/AlertTemplatesView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/settings/users',
      name: 'settings-users',
      component: () => import('@/views/SettingsUsersView.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/clients/:id/logs',
      name: 'client-logs',
      component: () => import('@/views/ClientLogsView.vue'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: '/clients/:id/config',
      name: 'client-config',
      component: () => import('@/views/ClientConfigView.vue'),
      meta: { requiresAuth: true },
      props: true
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/ProfileView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      redirect: '/'
    }
  ]
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const wsStore = useWebSocketStore()

  // Check if route requires authentication
  if (to.meta.requiresAuth) {
    // Check if user is authenticated
    if (!authStore.isAuthenticated) {
      // Try to restore session
      await authStore.checkAuth()
      
      if (!authStore.isAuthenticated) {
        // Redirect to login
        return next({ name: 'login', query: { redirect: to.fullPath } })
      }
    }

    // Check if route requires admin privileges
    if (to.meta.requiresAdmin && !authStore.isAdmin) {
      // Redirect to home if not admin
      return next({ name: 'home' })
    }

    // Ensure WebSocket is connected
    if (!wsStore.isConnected) {
      wsStore.connect()
    }
  } else {
    // Route doesn't require auth, but user is already logged in
    if (to.name === 'login' && authStore.isAuthenticated) {
      return next({ name: 'home' })
    }
  }

  next()
})

export default router
